export default function StatCard({ label, value, icon: Icon, trend, trendLabel, variant = 'default' }) {
  const iconColors = {
    default: 'bg-slate-100 text-slate-600',
    primary: 'bg-blue-100 text-blue-600',
    success: 'bg-green-100 text-green-600',
    warning: 'bg-amber-100 text-amber-600',
    danger: 'bg-red-100 text-red-600',
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-slate-500 truncate">{label}</p>
          <p className="mt-1 text-2xl font-bold text-slate-900">{value}</p>
          {trendLabel && (
            <p className={`mt-1 text-xs font-medium ${trend === 'up' ? 'text-green-600' : trend === 'down' ? 'text-red-600' : 'text-slate-500'}`}>
              {trendLabel}
            </p>
          )}
        </div>
        {Icon && (
          <div className={`flex-shrink-0 p-3 rounded-lg ${iconColors[variant]}`}>
            <Icon className="h-6 w-6" />
          </div>
        )}
      </div>
    </div>
  );
}
